import * as DialogPrimitive from '@radix-ui/react-dialog';
import { CircleAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '../Shared/Button/Button';
import { Separator } from '../Shared/Separator/Separator';
import {
  AlertDialogCancel,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/Domain/components/Shared/AlertDialog/AlertDialog';

type SheetConfirmationCloseDialogProps = {
  confirmationModalOpen: boolean;
  setConfirmationModalOpen: (open: boolean) => void;
  handleConfirmClose: () => void;
};

export const SheetConfirmationCloseDialog: React.FC<SheetConfirmationCloseDialogProps> = ({
  confirmationModalOpen,
  setConfirmationModalOpen,
  handleConfirmClose,
}: SheetConfirmationCloseDialogProps) => {
  const { t } = useTranslation('actions_page');
  return (
    <DialogPrimitive.Root open={confirmationModalOpen} onOpenChange={setConfirmationModalOpen}>
      <DialogPrimitive.Overlay className="!mt-0 absolute inset-0 bg-black/30 backdrop-blur-sm z-20" />

      <DialogPrimitive.Content
        className="absolute inset-0 flex items-center justify-center p-0 z-30 focus:outline-none"
        role="alertdialog"
        aria-modal="true"
      >
        <div className="space-y-4 bg-white rounded-lg p-6 max-w-md w-full shadow-lg">
          <AlertDialogHeader>
            <AlertDialogTitle>
              <CircleAlert className="inline size-4 bg-red-100 rounded-lg text-red-500 p-2 box-content" />
              {t('modal.close_modal.title')}
            </AlertDialogTitle>
          </AlertDialogHeader>

          <AlertDialogDescription>{t('modal.close_modal.subtitle')}</AlertDialogDescription>

          <Separator className="my-7" />
          <AlertDialogFooter>
            <AlertDialogCancel asChild>
              <Button size="md" variant="secondary">
                {t('modal.close_modal.button.cancel')}
              </Button>
            </AlertDialogCancel>

            <Button variant="danger" size="md" onClick={handleConfirmClose}>
              {t('modal.close_modal.button.continue')}
            </Button>
          </AlertDialogFooter>
        </div>
      </DialogPrimitive.Content>
    </DialogPrimitive.Root>
  );
};
